import { cookieNames } from '@elab/core/utils/constants';
import { getCookie } from '@elab/core/utils/cookie';
import { application } from '@elab/core/utils/appData';

/**
 * HOF used to pass data from cookies to components
 *
 * @author Sabin Pandelovitch
 *
 * @attr {Array} config - Array containg cookie configuration objects
 *
 * configuration object example
 * {
 *     name: 'eGiftCardCartEnding', // Name of the cookie or based on fromCookieNames, key in cookieNames constant
 *     propName: 'eGiftCardCartId',  // Name of the prop passed to the Component
 *     withBaseSite: true, // Adds the baseSiteID to the start of the cookie name
 *     fromCookieNames: true, // If true the cookie name is actually the key in the cookieNames constant
 * }
 *
 */

export default config => superclass => {
    class withCookieData extends superclass {
        connectedCallback() {
            if (super.connectedCallback) {
                super.connectedCallback();
            }

            if (config) {
                this.getCookieName = ({ fromCookieNames, name, withBaseSite }) =>
                    `${withBaseSite && application.baseSiteId}${
                        fromCookieNames ? cookieNames[name] : name
                    }`;

                this.updateCookieDataProps = () => {
                    const cookieData = config.reduce((acc, { propName, ...cookieNameParams }) => {
                        const cookieName = this.getCookieName(cookieNameParams);
                        const cookieValue = getCookie(cookieName);
                        acc = { ...acc, [propName]: cookieValue };
                        return acc;
                    }, {});

                    Object.assign(this, cookieData);
                };

                this.updateCookieDataProps();
            }

            this.__connected = true;
            if (this.afterConnect) {
                this.afterConnect();
            }
        }

        disconnectedCallback() {
            if (this.beforeDisconnect) {
                this.beforeDisconnect();
            }

            if (super.disconnectedCallback) {
                super.disconnectedCallback();
            }
        }
    }

    return withCookieData;
};
